document.addEventListener('DOMContentLoaded', function () {
  var MODAL_ID = 'promotion-popup';
  var OPEN_CLASS = 'modal--open';
  var SESSION_KEY = 'emmers_promotion_popup_shown';
  var TRIGGER_SELECTOR = '.js-promotion-popup-trigger';
  var MIN_TRIGGER_FONT_SIZE = 8;
  var ACTION_BAR_SELECTOR = '.js-action-bar';
  var MOBILE_BREAKPOINT = window.matchMedia('(max-width: 767px)');
  var ACTION_BAR_GAP = 12;

  var storage;
  try {
    storage = window.localStorage;
  } catch (e) {
    storage = null;
  }

  var modal = document.getElementById(MODAL_ID);
  var trigger = document.querySelector(TRIGGER_SELECTOR);
  var actionBar = document.querySelector(ACTION_BAR_SELECTOR);
  var actionBarObserver = null;

  function triggerTextFits(button, label) {
    return label.scrollHeight <= label.clientHeight + 1 && label.scrollWidth <= label.clientWidth + 1;
  }

  function fitPromotionTriggerLabel() {
    if (!trigger) return;

    var label = trigger.querySelector('span');
    if (!label) return;

    trigger.classList.remove('promotion-popup-trigger--expanded');
    trigger.style.removeProperty('--promotion-trigger-font-size');

    var currentSize = parseFloat(window.getComputedStyle(trigger).fontSize) || 12;

    while (currentSize > MIN_TRIGGER_FONT_SIZE && !triggerTextFits(trigger, label)) {
      currentSize -= 0.5;
      trigger.style.setProperty('--promotion-trigger-font-size', currentSize + 'px');
    }

    if (triggerTextFits(trigger, label)) return;

    trigger.classList.add('promotion-popup-trigger--expanded');
    trigger.style.removeProperty('--promotion-trigger-font-size');
    currentSize = parseFloat(window.getComputedStyle(trigger).fontSize) || 12;

    while (currentSize > MIN_TRIGGER_FONT_SIZE && !triggerTextFits(trigger, label)) {
      currentSize -= 0.5;
      trigger.style.setProperty('--promotion-trigger-font-size', currentSize + 'px');
    }
  }

  function updateTriggerOffset() {
    if (!trigger) return;

    if (!MOBILE_BREAKPOINT.matches || !actionBar || !actionBar.classList.contains('m-action-bar--visible')) {
      trigger.style.setProperty('--promotion-trigger-offset', '0px');
      return;
    }

    trigger.style.setProperty('--promotion-trigger-offset', actionBar.offsetHeight + ACTION_BAR_GAP + 'px');
  }

  function bindActionBarTracking() {
    if (!actionBar || actionBarObserver) {
      updateTriggerOffset();
      return;
    }

    actionBarObserver = new MutationObserver(updateTriggerOffset);
    actionBarObserver.observe(actionBar, {
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    updateTriggerOffset();
  }

  fitPromotionTriggerLabel();
  bindActionBarTracking();
  window.addEventListener('load', fitPromotionTriggerLabel);
  window.addEventListener('load', updateTriggerOffset);
  window.addEventListener('resize', fitPromotionTriggerLabel);
  window.addEventListener('resize', updateTriggerOffset);
  window.addEventListener('scroll', updateTriggerOffset, { passive: true });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitPromotionTriggerLabel);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateTriggerOffset);
  }

  if (!modal) return;

  // Already shown this session?
  if (storage && storage.getItem(SESSION_KEY) === 'true') {
    return;
  }

  function openModal() {
    modal.classList.add(OPEN_CLASS);
    document.documentElement.classList.add('has-open-modal');
    if (storage) {
      storage.setItem(SESSION_KEY, 'true');
    }
  }

  // Option A: open immediately when page loads
  // openModal();

  // Option B: open after a small delay (e.g. 3 seconds)
  setTimeout(openModal, 2500);
});
